import * as R from 'ramda';
import { Nomenclature } from '../../domain/Nomenclature';
import { createSelector, Selector } from 'reselect';
import { getNomenclaturesState, State } from '../reducers';

export const selectNomenclatures: Selector<State, Nomenclature[]> = createSelector(
  [getNomenclaturesState],
  R.identity
);
